<template>
<!-- 能不能吃分类组件 -->
  <div class="sorting_item" @click.stop="handleSorting(sortItem.id, sortItem.name)">
    <div class="sorting">
      <span>
        <img :src="sortItem.picture ? sortItem.picture : require('./../../../assets/images/canEat/sort_icon.png')" alt="">
      </span>
      <slot name="text"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SortingItem',
    data() {
      return {}
    },
    props: {
      sortItem: Object
    },
    methods: {
      handleSorting(id, name) {
        this.$emit('handleSortingFn', id, name)
      }
    }
  }
</script>

<style lang="less" scoped>
.sorting_item {
  width: 25%;
  .sorting {
    display: flex;
    flex-direction: column;
    text-align: center;
    padding: 10px 5px;
    box-sizing: border-box;
    span {
      width: 55px;
      height: 55px;
      margin: 0 auto;
      img {
        width: 55px;
        height: 55px;
      }
    }
    .text {
      color: #333333;
      font-size: 14px;
      line-height: 20px;
      margin-top: 2px;
    }
  }
}
</style>